export interface LineItemPrice {
  baseAmount: number;
  featureAmount: number;
  immediateAmount: number;
  totalAmount: number;
  redirectTo: string;
}

export interface LineItem {
  amount: string;
  currency: string;
  dateCreated: string;
  featureName: string;
  featureSlug: string;
  localizedPrice: string;
  uuid: string;
}

export interface Coupon {
  amountOff: number | null;
  code: string | null;
  currency: string | null;
  duration: 'once' | 'repeating' | 'forever';
  durationInMonths: number | null;
  isValid: boolean;
  name: string;
  percentOff: number | null;
  plans: string[] | null;
}

export enum SubscriptionStatus {
  active = 'active',
  canceled = 'canceled',
  past_due = 'past_due',
  pending = 'pending',
  trialing = 'trialing',
  unpaid = 'unpaid',
}

export interface UserSubscription {
  amount: number;
  basePlan: string;
  cancelAtPeriodEnd: boolean;
  canceledOn: string | null;
  coupon: Coupon | null;
  currency: string;
  currentPeriodEnd: string;
  dateCreated: string;
  finalPrice: string;
  interval: 'year' | 'month' | 'week' | 'day' | 'lifetime' | 'onetime';
  intervalCount: number;
  isPayingSubscription: boolean;
  lineItems: LineItem[];
  localizedPrice: string;
  planName: string;
  product: string;
  productName: string;
  status: SubscriptionStatus;
  totalPrice: string;
  trialEnd: string | null;
  uuid: string;
  parent?: string;
  reactivate?: boolean;
  willActivateOn?: string | null;
  pauseDate?: string | undefined;
}
